/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublisherUpdateModel } from '../../models/publisher-update-model';

export interface PublisherPost$Plain$Params {
      body?: PublisherUpdateModel
}

export function publisherPost$Plain(http: HttpClient, rootUrl: string, params?: PublisherPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, publisherPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<string>;
    })
  );
}

publisherPost$Plain.PATH = '/Publisher';
